var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-preview-container"},[_c('video',{ref:"player",staticClass:"player",attrs:{"src":_vm.singlePagePreviewUrl,"controlsList":"nodownload","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }